import { Card, Col, Form, Row, Select } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import SecondaryHeading from "components/assets/text/SecondaryHeading";
import { InputFilesWrapper } from "./styles";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { LoadInputAction } from "redux/actions/LoadInput";
import { requestFailure } from "redux/slices/app";
import { useSession } from "components/wrappers/SessionProvider";

const InputFilesDisabled = ({
  values
}: any) => {
  const dispatch = useAppDispatch();
  const session = useSession();
  const user = useAppSelector(state => state.user)
  const modelInfo = user.models[user.modelIndex];
  const jobInfo = user.jobs[user.jobIndex];
  const inputs = modelInfo.inputs;

  return (
    <InputFilesWrapper>
      <Card className="mt-24 card-custom">
        <SecondaryHeading title={"Input Files were used in " + jobInfo.jobName}>Input Files</SecondaryHeading>

        {inputs.length > 0 && (
          <Form layout="vertical" autoComplete="off">
            <Row gutter={[64, 12]}>
              {inputs.map((input: any) => {
                const selected = values?.[input.label];
                const filename = selected ? (selected.split("/").pop() || selected) : "";
                // Match the Run page's label: strip the `<s3_subfolder>/` prefix from the
                // stored value so the user sees `build.sql` rather than `sql/build.sql`.
                // user.config.inputs holds the path AFTER `<modelAlias>/input/`, so the
                // remaining work is just stripping the configured subfolder if any.
                const displayLabel = selected
                  ? (input.s3_subfolder
                    ? (selected.split(input.s3_subfolder + "/")[1] || selected)
                    : selected)
                  : "";
                return (
                  <Col span={8} key={input.label}>
                    <Form.Item
                      label={(
                        <span className="input-label-row">
                          <span>{input.label}</span>
                          <span className="input-label-actions">
                            {selected && (
                              <button
                                type="button"
                                className="label-icon-btn"
                                title={`Download ${filename} so you can inspect its contents and shape`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  dispatch(LoadInputAction(
                                    session,
                                    modelInfo.alias,
                                    "input/" + selected,
                                    filename,
                                  )).catch(() => dispatch(requestFailure()));
                                }}
                              >
                                <DownloadOutlined />
                              </button>
                            )}
                          </span>
                        </span>
                      )}
                    >
                      <Select
                        placeholder="Select one"
                        className="disabledSelect"
                        value={selected}
                        options={selected ? [{ value: selected, label: displayLabel }] : []}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                )
              })}
            </Row>
          </Form>
        )}
      </Card>
    </InputFilesWrapper>
  );
};

export default InputFilesDisabled;
